import { liveNursesPostedJobReducer } from 'src/app/recruiting/candidates/live-nurses-new/store/reducers/posted-job.reducer';
import { liveNursesSubmittalNotesReducer } from 'src/app/recruiting/candidates/live-nurses-new/store/reducers/submittal-notes.reducer';
import { liveNursesJobOptionsReducer } from 'src/app/recruiting/candidates/live-nurses-new/store/reducers/job-options.reducer';
import { liveNursesSubmittalJobReducer } from 'src/app/recruiting/candidates/live-nurses-new/store/reducers/submittal-job.reducer';
import { liveNursesSubmittalReducer } from 'src/app/recruiting/candidates/live-nurses-new/store/reducers/submittal.reducer';
import { liveNursesJobPercentagesReducer } from './job-percentages.reducer';

export const liveNursesReducers = {
    postedJobState: liveNursesPostedJobReducer,
    submittalNotesState: liveNursesSubmittalNotesReducer,
    jobOptionsState: liveNursesJobOptionsReducer,
    submittalJobsState: liveNursesSubmittalJobReducer,
    submittalState: liveNursesSubmittalReducer,
    jobPercentagesState: liveNursesJobPercentagesReducer
};
